import { Routes, Route } from 'react-router-dom'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import BackToTop from './components/BackToTop'
import ChatWidget from './components/ChatWidget'
import Home from './pages/Home'
import About from './pages/About'
import MeetTheTeam from './pages/MeetTheTeam'
import Packages from './pages/Packages'
import PackageDetail from './pages/PackageDetail'
import DiscoverySpecials from './pages/DiscoverySpecials'
import Blog from './pages/Blog'
import BlogDetail from './pages/BlogDetail'
import Contact from './pages/Contact'
import SeoDefaults from './components/SeoDefaults'
import AdminRedirect from './pages/AdminRedirect'

function App() {
  return (
    <div className="min-h-screen bg-indojet-light flex flex-col">
      <SeoDefaults />
      <Navbar />
      <main className="flex-grow">
        <Routes>
          <Route path="/admin/*" element={<AdminRedirect />} />
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/meet-the-team" element={<MeetTheTeam />} />
          <Route path="/packages" element={<Packages />} />
          <Route path="/packages/:slug" element={<PackageDetail />} />
          <Route path="/discovery-specials" element={<DiscoverySpecials />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
      <Footer />
      <BackToTop />
      <ChatWidget />
    </div>
  )
}

export default App
